// Capitalise first letter
const ucfirst = (str) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

// Limit String
const limitLength = (string, limit) => {
	if (!string || !limit) { return; }
	return (limit - string.length) + '/' + limit + ' characters remaining';
};

// Limit String
const underLimit = (string, limit = 0) => {
	if (!string) { return false; }
	return string.length > limit;
};

//
const pluralise = (count = 0, plural = '', singular = '') => {
	let locale = navigator.language ? navigator.language : 'au-AU';
	count = parseFloat(count) || 0;
	var use = singular;
	if ([1, -1].indexOf(count) < 0) { use = plural; }
	return new Intl.NumberFormat(locale).format(count) + ' ' + use;
};

// TODO: This is a security risk
// Example: https://example"onmouseover="alert(document.cookie)
//parse content
const parseContent = (content) => {
	// Strip tags
	var safe = (content || "")
		.replace(/<style[^>]*>.*<\/style>/gm, '')
		// Remove script tags and content
		.replace(/<script[^>]*>.*<\/script>/gm, '')
		// Remove all opening, closing and orphan HTML tags
		.replace(/(<([^>]+)>)/igm, "")
		// Remove leading spaces and repeated CR/LF
		.replace(/([\r\n]+ +)+/gm, '');

	// Parse
	return (safe || "")
		// Add Links - Consider https://github.com/SoapBox/linkifyjs/
		.replace(
			/([^\S]|^)(((https\:\/\/)|(www\.))(\S+))/gi,
			function (match, space, url) {
				var hyperlink = url;
				if (!hyperlink.match('^https?:\/\/')) {
					hyperlink = 'https://' + hyperlink;
				}
				return space + '<a href="' + hyperlink + '" target="_blank">' + url + '</a>';
			}
		)
		// replace line breaks
		.replace(/\n\s*\n/g, '<br><br>')
		// replace line breaks
		.replace(/\n/g, '<br>');
};

export {
	ucfirst,
	limitLength,
	underLimit,
	pluralise,
	parseContent
};